import { render, staticRenderFns } from "./fxServiceSalesDetailTable.vue?vue&type=template&id=2faa6013"
import script from "./fxServiceSalesDetailTable.vue?vue&type=script&lang=js"
export * from "./fxServiceSalesDetailTable.vue?vue&type=script&lang=js"
import style0 from "./fxServiceSalesDetailTable.vue?vue&type=style&index=0&id=2faa6013&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports